import api from '@edu-fe/api'
import Cookie from 'js-cookie'

export default {
  name: 'clockIn',
  getClockState: api.create(`/course/sign/status?userId=${Cookie.get('openid')}`),
  clockIn: api.create('/course/signin', {
    method: 'post',
    formData: true
  }),
  getShareState: api.create('/course/share')
}
